/**
 * User: daletan
 * Date: 6/23/14
 * Time: 10:44 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#isMobile
 * js/global/core/dibs.js#isTouchDevice
 * dibs.isMobile
 * dibs.isTouchDevice
 */

'use strict';
var _navigator = global.navigator;

/**
 * Detect if user is on mobile device
 * this is a jenky solution since it relies on the user agent
 * it should rely on feature detection instead
 */
module.exports = {
    Android: function (ua) {
        return (/Android/i).test(ua || _navigator.userAgent);
    },
    BlackBerry: function (ua) {
        return (/BlackBerry/i).test(ua || _navigator.userAgent);
    },
    BlackBerry10: function (ua) {
        return (/BB10/i).test(ua || _navigator.userAgent);
    },
    iPhone: function (ua) {
        return (/iPhone/i).test(ua || _navigator.userAgent);
    },
    iPad: function (ua) {
        return (/iPad/i).test(ua || _navigator.userAgent);
    },
    iPod: function (ua) {
        return (/iPod/i).test(ua || _navigator.userAgent);
    },
    iOS: function (ua) {
        return this.iPhone(ua) || this.iPad(ua) || this.iPod(ua);
    },
    Opera: function (ua) {
        return (/Opera Mobi/i).test(ua || _navigator.userAgent);
    },
    Windows: function (ua) {
        return (/IEMobile/i).test(ua || _navigator.userAgent);
    },
    iOSVersion: function (version, ua) {
        var r = new RegExp('(iPad|iPhone|iPod);.*CPU.*OS ' + version + '_\\d', 'i');
        return r.test(ua || _navigator.userAgent);
    },
    any: function (ua) {
        var isMobile = false;
        var blacklist = [
            'hasTouch',
            'isTouchDevice',
            'any',
            'iOSVersion'
        ];

        for (var p in this) {
            if (this.hasOwnProperty(p) && blacklist.indexOf(p) === -1) {
                isMobile = this[p](ua || _navigator.userAgent);
                if (isMobile) {
                    return isMobile;
                }
            }
        }
        return isMobile;
    },
    hasTouch: function () {
        return this.isTouchDevice();
    },
    /**
     * TODO: delete references to isTouchDevice & move logic to hasTouch
     * @deprecated - use hasTouch instead
     * @returns {boolean}
     */
    isTouchDevice: function () {
        // http://stackoverflow.com/a/4819886
        // reference  GFoley83 Sep 4 '13 at 6:20 comment
        //
        // added non-prefixed maxTouchPoints based on this post:
        // http://msdn.microsoft.com/en-us/library/ie/hh772144%28v=vs.85%29.aspx
        return 'ontouchstart' in global || (!!(_navigator.msMaxTouchPoints) || !!(_navigator.maxTouchPoints));
    }
};


//DETECT TOUCH CAPABILITIES



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/mobileCheck.js
// module id = 284
// module chunks = 63